import React from 'react';
import {connect, useSelector} from 'umi';
import DataSourceRelation from '../../Analysis/components/HeaderData/dataSourceRelation';
import { ITableJoinRelation } from '../../Analysis/components/HeaderData/interface';
import TableFieldList from '../../Analysis/components/TableFieldList';
import type { IColumnInfo } from '@dbl/core/dataSource';
import type { IGetTableInfoDto } from '@dbl/services/dataSource';
import { namespace } from '../model';


export default connect((state: any) => {
  const {
    dataTables,
    dataTableJoinRelations,
    columnFilters = [],
    columnMetrics = [],
    columnDimensions = [],
  }: {
    tableWidth: number;
    dataTableJoinRelations: ITableJoinRelation[];
    dataTables: IGetTableInfoDto[];
    columnFilters: IColumnInfo[];
    columnMetrics: IColumnInfo[];
    columnDimensions: IColumnInfo[];
  } = state[namespace];
  return {
    dataTables,
    dataTableJoinRelations,
    columnFilters,
    columnMetrics,
    columnDimensions,
  };
})(DataSource);

function DataSource(props: any) {
  const { gameCode } = useSelector((state) => ({gameCode: state.datalab.gameCode}));

  return (
    <>
      <DataSourceRelation
        {...props}
        gameCode={gameCode}
        namespace={namespace}
      />
      <TableFieldList {...props} namespace={namespace} />
    </>
  );
}
